import { Component, OnInit,Renderer2, ChangeDetectorRef, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { MatDialog} from '@angular/material';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ConfirmationDialogService } from '../shared/confirmation-dialog/ConfirmationDialogService';
import { DOCUMENT } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CardXResponse } from '../shared/models/CardXResponse';
import { CardRegistrationService } from '../services/card-registration.service';
import { CardXResponseSaveRequest } from '../shared/models/CardXResponseSaveRequest';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cc-registration-form',
  templateUrl: './card-registration.component.html',
  styleUrls: ['./card-registration.component.css']
})
export class CardRegistrationComponent implements OnInit {
  title = 'Card Registration Form';
  snapshot: any;
  @ViewChild('pay_with_cardx') 
  private pay_with_cardx: ElementRef;	
  cardXResponse: CardXResponse;
  urlToken:any;
  content:any;
  type:any;
  userName:any;
  customerNumber:any;
  customerNumber1:any;
  cardXResponseSaveRequest: CardXResponseSaveRequest;
  errors=new Set<String>();
  showSuccessMessage:boolean;
  saveResponseMessage:string;
  
  constructor(
    private renderer: Renderer2,
    private _notificationService: NotificationService, 
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private confirmationDialogService:ConfirmationDialogService,
    private cdRef:ChangeDetectorRef,
    private router: Router,
    private formBuilder: FormBuilder,
    private cardXRegistrationService: CardRegistrationService,
    @Inject(DOCUMENT) private _document) 
    { }

  //this is to avoid console errors
  ngAfterViewChecked()
  {
    this.cdRef.detectChanges(); 
  }

  ngOnInit() {
    
    this.errors.clear();
    this.showSuccessMessage = false;
    this.userName = null;
    this.customerNumber = null;
    this.customerNumber1 = null;
    this.cardXResponse = new CardXResponse();
    this.route.queryParams.subscribe(params => {
      this.urlToken = params.token;
      this.type = params.type;
      this.validateToken();
    });
  }

  validateToken()
  {
    this.cardXRegistrationService.vaidateToken(this.urlToken, this.type).subscribe(response =>{

      if(response != null && response.status == "success")
      {
        this.content = response.data.content;

        let splittedString = this.content.split(",");
        
        if(this.type == "CREGINT")
        {
          this.customerNumber = splittedString[1].split("=").pop();
          this.userName = splittedString[2].split("=").pop();
        }
        else{
          this.customerNumber = splittedString[0].split("=").pop();
        }
        
        this.loadScript();
        //Below logic is written to listen to change events on input text field with id response_target
        const input = document.querySelector('#response_target');
        
        const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) =>
          this.onSubmit());
        });
        
        observer.observe(input, {
        attributes: true,
        childList: true,
        characterData: true
        });
        //
      }
      else if(response != null && response.status == "error")
      {
        this.router.navigate(['/error']);
      }
    });
  }

  loadScript() 
  {
    const script = this.renderer.createElement('script');
    script.innerHTML = '';
    script.id= 'cardx_lightbox_script',
    script.src = environment.lightbox_src;
    script.setAttribute('data-button','#pay_with_cardx');
    script.setAttribute('data-target','#response_target');
    script.setAttribute('data-account',environment.lightbox_data_account);
    script.setAttribute('data-mode',environment.lightbox_data_mode);
    script.setAttribute('data-amount',environment.lightbox_data_amount);
    script.async = false;
    script.defer = true;
    this.renderer.appendChild(this._document.body,script);
  }

  onSubmit(){
    let saveRecord:boolean = false;
    if((<HTMLInputElement>document.getElementById("response_target")).value != null && (<HTMLInputElement>document.getElementById("response_target")).value != "")
    {
      this.cardXResponse = JSON.parse((<HTMLInputElement>document.getElementById("response_target")).value);
    }
    this.cardXResponseSaveRequest = new CardXResponseSaveRequest();
    
    if(this.cardXResponse != null && this.cardXResponse.pt_order_id != "undefined" && this.cardXResponse.pt_order_id != null)
    {
      if(this.customerNumber != null)
      {
        this.cardXResponseSaveRequest.customerNumber = this.customerNumber;
        this.cardXResponseSaveRequest.userName = this.userName;
        saveRecord = true;
      }

      if(saveRecord)
      {
        this.cardXResponseSaveRequest.cardXresponse = this.cardXResponse
        this.cardXRegistrationService.saveCardXResponse(this.cardXResponseSaveRequest).subscribe(response =>
        {
          if(response != null && response.status == "success")
          {
            this.saveResponseMessage = response.message;
            this.showSuccessMessage = true;
          }
        },
        (error) => {
          console.log('Error', error);
          console.log("Some error occured while saving data");
        });
      }
      
    }
    
  }

  //It validates required fields should not be null
  validateRequiredFields(conrol:any):boolean
  {
    if(conrol!=null && conrol.name!=null)
    {
      if(!conrol.value || conrol.value=="" || conrol.value==undefined || conrol.value==null)
      {
      this.errors.add(conrol.name);
      return true;
      }
      else{
        this.errors.delete(conrol.name);
        return false;
      }  
    } 
  }

}
